import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from 'reactstrap';
import defaultAvatar from '@src/assets/images/portrait/small/avatar-blank.png';
import { useDispatch, useSelector } from 'react-redux';
import { Calendar, Power, Settings } from 'react-feather';
import Avatar, { AvatarStatus } from '@components/avatar';
import { useGetAccountInfoQuery } from '@src/features/api/AccountApi';
import { logoutUser } from '@src/features/authentication/AuthenticationSlice';
import { Link } from 'react-router-dom';
import { RootState } from '@src/app/store';

const UserDropdown = () => {
  const dispatch = useDispatch();

  const { tokenData } = useSelector((state: RootState) => state.auth);

  const { data: account } = useGetAccountInfoQuery(tokenData!, {
    skip: !tokenData,
  });

  const onLogoutClick = (ev: any) => {
    ev.preventDefault();
    dispatch(logoutUser());
  };

  return (
    <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
      <DropdownToggle
        href="/"
        tag="a"
        className="nav-link dropdown-user-link"
        onClick={(e) => e.preventDefault()}
      >
        <div className="user-nav d-sm-flex d-none">
          <span className="user-name fw-bold text-capitalize">
            {account?.firstName && `${account.firstName} ${account.lastName}`}
          </span>
          {/* <span className="user-status">Customer</span> */}
        </div>
        <Avatar
          img={defaultAvatar}
          imgHeight="32"
          imgWidth="32"
          status={AvatarStatus.Online}
        />
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem tag={Link} to="/appointments">
          <Calendar size={14} className="me-75" />
          <span className="align-middle">Appointments</span>
        </DropdownItem>
        <DropdownItem tag={Link} to="/account-settings">
          <Settings size={14} className="me-75" />
          <span className="align-middle">Settings</span>
        </DropdownItem>
        <DropdownItem tag="a" href="#" onClick={onLogoutClick}>
          <Power size={14} className="me-75" />
          <span className="align-middle">Sign Out</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default UserDropdown;
